import React from "react";
import styled from "styled-components";
import { usePilotageRhStore } from "../../../store/usePilotageRhStore";
import { calcDelta } from "../../../functions/compute";
import { fmt1Signed } from "../../../functions/format";

/**
 * Affiche une valeur ; si la comparaison "vs précédent" est activée pour la
 * section, le delta est affiché en petit à côté de la valeur.
 *
 * `delta` :
 *  - undefined → delta de démonstration (sections non branchées sur l'API)
 *  - null      → pas de comparaison disponible, rien d'affiché
 *  - number    → delta réel (en % ou en points selon `isPct`)
 */
const DeltaValue = ({ section, seed, isPct = false, delta, children }) => {
    const compareOn = usePilotageRhStore((s) => !!s.compare[section]);
    const filters = usePilotageRhStore((s) => s.filters);

    if (!compareOn || delta === null) return <>{children}</>;

    const value = delta === undefined ? calcDelta(filters, seed) : delta;

    return (
        <>
            {children}
            <Delta $up={value >= 0}>
                {fmt1Signed(value)}
                {isPct ? " pt" : "%"}
            </Delta>
        </>
    );
};

export default DeltaValue;

const Delta = styled.span`
    font-size: var(--prh-font-xs);
    font-weight: 600;
    margin-left: 6px;
    vertical-align: middle;
    color: ${({ $up }) =>
        $up ? "var(--prh-violet-dark)" : "var(--prh-muted)"};
`;
